import { render, staticRenderFns } from "./GalleryPopupImageThumbnail.vue?vue&type=template&id=463c1079&"
import script from "./GalleryPopupImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./GalleryPopupImageThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports